import React, { useEffect, useState } from "react";
import Api from "../../../Api/api";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { useStateValue } from "../../../states/StateProvider";
import { AES, enc } from "crypto-js";

const AdminStrings = () => {
    const [loading, setLoading] = useState(true);
    const [stringList, setStringList] = useState([]);
    const [selectedId, setSelectedId] = useState('');
    const [selectedLabel, setSelectedLabel] = useState('');
    const [value, setValue] = useState('');

    const [{ secretKey, portal }, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8));

    useEffect(() => {
        getData();
    }, [portal]);

    const getData = async () => {
        if (portal) {
            setLoading(true);
            try {
                const response = await Api().get(`/sp_getDataAdminStrings/${portal}`);
                setStringList(response.data || []);
            } catch (error) {
                toast.error("Fehler beim Laden der Admin-Strings!");
            }
            setLoading(false);
        }
    };

    const handleSelect = (e) => {
        const id = e.target.value;
        setSelectedId(id);
        const selected = stringList.find(item => item.ID === id);
        setSelectedLabel(selected?.Bezeichnung || '');
        setValue(selected?.Inhalt || '');
    };

    const handleSave = async () => {
        if (!selectedId) return;
        setLoading(true);
        try {
            await Api().post(`/sp_setString`, {
                portal,
                id: selectedId,
                value
            });
            toast.success("String erfolgreich gespeichert!");
            getData();
        } catch (error) {
            toast.error("Fehler beim Speichern des Strings!");
        }
        setLoading(false);
    };

    function portalSelect(e) {
        dispatch({ type: 'SET_PORTAL', item: e.target.value });
        localStorage.setItem('portal', e.target.value);
        setStringList([]);
    }

    return (
        <div className="dashboardContainer text-left">
            <div className='flex justify-start items-center pb-5'>
                <h2 className='text-2xl'>Admin-Strings verwalten</h2>
                <div className='flex justify-start items-center w-fit bg-transparent py-2 px-4 ml-4 rounded-sm'>
                    <p className='w-fit mr-2 text-grey'>Portal: </p>
                    <select
                        disabled={loading}
                        className='text-mainBlue bg-transparent border border-offWhite rounded-sm'
                        onChange={portalSelect}
                        value={portal}
                    >
                        <option value='dgg'>DGG</option>
                        <option value='ruv'>R+V</option>
                    </select>
                </div>
            </div>

            <div className='bg-white p-6 rounded shadow'>
                {loading ? (
                    <div className="text-center py-8">
                        <BeatLoader color="#1E40AF" size={10} />
                    </div>
                ) : (
                    <>
                        <div className="mb-6">
                            <label className="text-lg text-grey me-3">String auswählen</label>
                            <select
                                className="w-auto border border-offWhite rounded px-3 py-2"
                                onChange={handleSelect}
                                value={selectedId}
                            >
                                <option value="">-- bitte wählen --</option>
                                {stringList.map(item => (
                                    <option key={item.ID} value={item.ID}>
                                        {item.Bezeichnung}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {selectedId && (
                            <div className="bg-white p-4 rounded shadow">
                                <label className="block text-lg text-grey mb-3">{selectedLabel}</label>
                                <input
                                    className="w-full border border-offWhite rounded px-3 py-2 mb-4"
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                />
                                <button
                                    className="bg-mainBlue text-white px-4 py-2 rounded-full hover:bg-blue-700"
                                    onClick={handleSave}
                                    disabled={loading}
                                >
                                    {loading ? <BeatLoader color="white" size={4} /> : 'Speichern'}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AdminStrings;
